<template>
  <div class="wrapper">
    <nav-bar/>
    <title-bar :title="$route.meta.title"/>
    <van-uploader :after-read="onRead" enctype="multipart/form-data" style="width:100%">
      <div class="avatar">
        <img :src="$store.state.userInfo.avatar | thumbnail(106,106)">
        <span class="text">修改头像</span>
        <span class="arrow">
          <van-icon name="arrow"/>
        </span>
      </div>
    </van-uploader>
    <div class="info">
      <ul>
        <li class="info-item" @click="editName">
          <span>昵称</span>
          <span>{{$store.state.userInfo.name}}</span>
          <span>
            <van-icon name="arrow"/>
          </span>
        </li>
        <li class="info-item">
          <span>手机</span>
          <span>{{$store.state.userInfo.mobile}}</span>
          <span>
            <van-icon name="arrow"/>
          </span>
        </li>
        <!-- <li class="info-item">
                <span>邮箱</span>
                <span>{{$store.state.userInfo.avatar}}</span>
                <span>
                    <van-icon name="arrow" />            
                </span>
        </li>-->
        <li class="info-item" @click="editAutograph">
          <span>个性签名</span>
          <span class="styleName">{{$store.state.userInfo.introduction}}</span>
          <span>
            <van-icon name="arrow"/>
          </span>
        </li>
      </ul>
    </div>
    <!-- <div>
      <van-button type="default" class="exit" @click="exit">退出登录</van-button>
    </div>-->
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { userUpdate, QinniuToken } from "@/api/userReq";
import TitleBar from "@/components/TitleBar.vue";
import { Icon, Button, Uploader } from "vant";
import { mapActions } from "vuex";
import * as qiNiu from "qiniu-js";
export default {
  components: {
    NavBar,
    TitleBar,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Uploader.name]: Uploader
  },
  data() {
    return {
      userInfo: {
        avatar: this.$store.state.userInfo.avatar
      }
    };
  },
  methods: {
    ...mapActions(["LogOut"]),
    exit() {
      this.LogOut().then(res => {
        this.$router.replace("/login");
      });
    },
    editName() {
      this.$router.push({
        path: "/edituser",
        query: {
          name: "name",
          title: "修改名称",
          val: this.$store.state.userInfo.name
        }
      });
    },
    editAutograph() {
      this.$router.push({
        path: "/edituser",
        query: {
          name: "introduction",
          title: "修改个性签名",
          val: this.$store.state.userInfo.introduction
        }
      });
    },
    // 更换头像
    onRead(file) {
      QinniuToken()
        .then(config => {
          qiNiu.upload(file.file, config.key, config.token).subscribe(
            total => {},
            error => {
              console.log(error);
            },
            response => {
              // success
              // 设置对应的头像文件
              this.userInfo.avatar = `${config.domain}/${config.key}`;
              userUpdate(this.userInfo)
                .then(res => {
                  this.$store.dispatch("ChangeVmUserInfo", {
                    category: "avatar",
                    msg: this.userInfo.avatar
                  });
                })
                .catch(err => {
                  console.log(err);
                });
            }
          );
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped lang="less">
.wrapper {
  .avatar {
    display: flex;
    align-items: center;
    width: 95%;
    height: 78px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 1px 10px 21px 0px rgba(66, 83, 103, 0.08);
    border-radius: 10px;
    padding: 10px 20px;
    margin-top: 25px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    img {
      border-radius: 50%;
      width: 18%;
      width: 56px;
      height: 56px;
      vertical-align: middle;
    }
    .text {
      margin-left: 20px;
      font-weight: 500;
      color: rgba(132, 132, 132, 1);
    }
    .arrow {
      flex: auto;
      text-align: right;
    }
  }
  .info {
    width: 95%;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(255, 255, 255, 1);
    box-shadow: 1px 10px 21px 0px rgba(66, 83, 103, 0.08);
    border-radius: 10px;
    padding: 0 20px;
    margin-top: 35px;
    .info-item {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid rgba(236, 239, 240, 1);
      span:nth-of-type(1) {
        font-weight: 500;
        color: rgba(132, 132, 132, 1);
      }
      span:nth-of-type(2) {
        margin-left: 55px;
        font-weight: 500;
        color: rgba(49, 49, 49, 1);
      }
      span:nth-of-type(3) {
        float: right;
      }
      .styleName {
        margin-left: 28px !important;
      }
    }
  }
  .exit {
    font-weight: 500;
    color: #2a2a2a;
    font-size: 16px;
    margin-top: 100px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 95%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 1px 9px 21px 0px rgba(73, 79, 86, 0.06);
    border-radius: 5px;
  }
}
</style>